var map;
var geocoder;
var position;
var infowindow;
var directionsRenderer;

var marker1;
var marker2;
var google;

function destinationFocus()
{
    jQuery('#destination').val('');
    jQuery('#destination').css({'color': '#000000'});
    jQuery('#destination').attr('onfocus','').unbind('focus');
}

function getInfoWindowEvent(marker, content)
{
    infowindow.close()
    infowindow.setContent(content);
    infowindow.open(map, marker);
}

function initialize() 
{                         
    infowindow = new google.maps.InfoWindow({
        maxWidth:300
    });
            
    geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'address': address }, function(results, status) 
        {
            if(status == google.maps.GeocoderStatus.OK)
                {
                position = results[0].geometry.location;

                map.setCenter(position);

                getInfoWindowEvent(new google.maps.Marker({ 
                    position: position, 
                    map: map, 
                    visible:false
                }), createInfoWindowContent() );
            } 
    });

    map = new google.maps.Map(document.getElementById('map_canvas'),{ 
        zoom: 10, 
        mapTypeId: google.maps.MapTypeId.ROADMAP, 
        position: position 
    });
}

function showTab(id)
{
    jQuery('.tab').hide();
    jQuery('#'+id).show();
    jQuery('.tab-name').removeClass('tab-name-active');
    jQuery('#tab-name-'+id).addClass('tab-name-active');
}

function getDirections()
{    
    if(directionsRenderer !== null && directionsRenderer !== undefined){
        directionsRenderer.setMap(null);
        marker1.setMap(null);
        marker2.setMap(null);
    }

    directionsRenderer = new google.maps.DirectionsRenderer({
            draggable: true,
            suppressInfoWindows: true,
            suppressMarkers: true
    });
    directionsRenderer.setMap(map);
    
    var directionsService = new google.maps.DirectionsService();

    var bestemming = (jQuery('#destination').val());
    bestemming = bestemming.replace(/(^\s*)|(\s*$)/g, "");
    if(bestemming.match(/^[1-9][0-9]{3}[\s][A-Z]{2}$/i)) 
    {
        bestemming += ", Nederland";
    } 
    
    directionsService.route({
        origin: address,
        destination: bestemming,

        travelMode: google.maps.DirectionsTravelMode.DRIVING,
        unitSystem: google.maps.DirectionsUnitSystem.METRIC
    }, function(response, status) 
        {
            if (status == google.maps.DirectionsStatus.OK) 
            {
                directionsRenderer.setDirections(response);
                var leg = response.routes[ 0 ].legs[ 0 ];
                marker1 = new google.maps.Marker({ 
                    position: leg.start_location, 
                    map: map 
                });
                google.maps.event.addListener(marker1, 'click', function() {
                    getInfoWindowEvent(marker1, createInfoWindowContent());      
                });

                marker2 = new google.maps.Marker({
                        position: leg.end_location,
                        map: map
                });
                                
                google.maps.event.addListener(marker2, 'click', function() {
                    getInfoWindowEvent(marker2, leg.end_address);      
                });  

            } else if(status == google.maps.DirectionsStatus.ZERO_RESULTS){
                alert('De opgegeven postcode kon niet worden gevonden, probeert u het nog eens.');
            } else {
                alert('Error: ' + status);
            }
    });       
}

if ($('#map_canvas').length > 0)
{
    google.maps.event.addDomListener(window, 'load', initialize);
}
